import * as React from 'react'

import { computeSize } from '../shared'
import type { IconProps } from '../shared'

/**
 * Twitter video play icon with circular blue background and white play button.
 */
const PlayIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 'medium', className, ...props }, ref) => {
    const computedSize = computeSize(size)

    return (
      <svg
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <rect width="40" height="40" rx="20" fill="#1DA1F2" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.9255 12.3581C16.8459 11.5931 15 12.1349 15 13.2168L15 26.7832C15 27.8651 16.8459 28.4069 17.9255 27.6419L27.4981 20.8587C28.1673 20.3844 28.1673 19.6156 27.4981 19.1413L17.9255 12.3581Z"
          fill="white"
        />
      </svg>
    )
  },
)

PlayIcon.displayName = 'TwitterPlayIcon'

export { PlayIcon }
